import { ContentContainer } from '../../components/ContentContainer';
import { Typography } from '../../components/ui/Typography';
import type { PopulatedWine } from './types';

interface WineDescriptionProps {
  wine: PopulatedWine;
}

export const WineDescription = ({ wine }: WineDescriptionProps) => {
  return (
    <div className="lg:hidden">
      <ContentContainer>
        <Typography 
          variant="heading3" 
          as="h2" 
          className="mb-3 md:mb-4 lg:mb-6"
        >
          Description
        </Typography>
        {wine.description ? (
          <Typography
            variant="bodyLarge"
            as="p"
          >
            {wine.description}
          </Typography>
        ) : (
          <Typography
            variant="bodyLarge"
            as="p"
            className="text-gray-500 italic"
          >
            No description available
          </Typography>
        )}
        {(wine as unknown as { wineSource?: string }).wineSource &&
         (wine as unknown as { wineSource?: string }).wineSource !== 'manual' && (
          <span
            className="inline-flex items-center mt-2 px-2 py-0.5 text-[11px] uppercase tracking-wide rounded-full bg-amber-50 text-amber-800 border border-amber-200"
            title="Auto-extracted from the venue's website. Not yet reviewed by the venue."
          >
            Auto-extracted
          </span>
        )}
      </ContentContainer>
    </div>
  );
};